import React from "react"
import { useSelector } from "react-redux"
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Alert,
} from "@mui/material"

import { RootState } from "../../../store/configureStore"
import { useStudentMinutes } from "../../../hooks/useStudentMinutes"
import { phoneNumber } from "../../../config"

// This is for Illinois 6x6 students and can be removed once all 6x6 students are done.
const IllinoisCallToBookDialog = () => {
  const {
    firebase: { auth },
  } = useSelector((state: RootState) => state)
  const [dialogSeen, setDialogSeen] = React.useState(false)
  const studentCredits = useStudentMinutes(auth.uid)
  const shouldShowWarning =
    studentCredits?.observationMinutesPurchased &&
    studentCredits.observationMinutesPurchased > 0

  if (!shouldShowWarning) {
    return null
  }

  if (dialogSeen) {
    return (
      <Alert severity="warning">
        If you are looking to schedule observation hours please call us at{" "}
        {phoneNumber}.
      </Alert>
    )
  }

  return (
    <Dialog
      open={!dialogSeen}
      onClose={() => setDialogSeen(true)}
      data-cy="call-to-book-dialog"
    >
      <DialogTitle>6x6 Package Students</DialogTitle>
      <DialogContent>
        It looks like you purchased the 6x6 package. This means you have 6
        driving hours and 6 observation hours to schedule. Currently, online
        booking is only for driving hours. If you are looking to schedule an
        observation lesson please call to book at {phoneNumber}.
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setDialogSeen(true)
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default IllinoisCallToBookDialog
